import { Injectable } from '@angular/core';
import { ApiUserPasswordService } from './api-call-providers/api-user-password.service';
import { AlertService } from './alert.service';
import { Events } from "ionic-angular";
import { EVENTS_CONFIG } from './../configs/events.config';

@Injectable()
export class UserService {

  constructor(
    private apiUserPasswordService: ApiUserPasswordService,
    private alertService: AlertService,
    private events: Events
  ) {
  }

  /**
   * パスワード更新
   * @param params 
   */
  updatePassword(params): Promise<any> {
    return this.apiUserPasswordService.post(params).then((res) => {
      if (res && res.result) {
        // tokenを更新する
        this.events.publish(EVENTS_CONFIG.TOKEN, res.token);

        this.alertService.basic('＊ 確認 ＊', 'パスワードが正常に<br>変更されました', ()=>{})        
        return true;
      } else {
        this.alertService.basic('＊ 確認 ＊', 'パスワードの更新に<br>失敗しました', ()=>{})
      }
      return false;
    }).catch((err) => {
      this.alertService.basic('＊ 確認 ＊', '以前登録したパスワードは<br>使用できません。', ()=>{})
      return false;
    })
  }

}



// WEBPACK FOOTER //
// ./src/providers/user.service.ts